const root = `${process.env.PUBLIC_URL || ""}/audio/streak`;
export const STREAK_RECORDINGS = ["Boo-yah.m4a", "Boo-yaka.m4a", "taa-dow.m4a"].map(name => `${root}/${name}`);
let nextIndex = 0;
export function nextStreakRecording() {
  try {
    const saved = window.localStorage.getItem("hhkd.wordStreak.nextVoice");
    if (/^[0-2]$/.test(saved)) nextIndex = Number(saved);
  } catch (e) {}
  const recording = STREAK_RECORDINGS[nextIndex];
  nextIndex = (nextIndex + 1) % STREAK_RECORDINGS.length;
  try { window.localStorage.setItem("hhkd.wordStreak.nextVoice", String(nextIndex)); } catch (e) {}
  return recording;
}

// One cancellable queue for correct-word chimes, streak voices, and victory voices.
export function createWordAudio() {
  let queue = Promise.resolve();
  let generation = 0;
  let cancelCurrent = null;
  const stop = () => {
    generation += 1;
    if (cancelCurrent) cancelCurrent();
    cancelCurrent = null;
    queue = Promise.resolve();
  };
  const play = (chime, milestone, recordingOverride) => {
    const version = generation;
    const recording = recordingOverride || STREAK_RECORDINGS[{ 3: 0, 5: 1, 10: 2 }[milestone]] || null;
    queue = queue.then(async () => {
      if (version !== generation) return;
      const controller = new AbortController();
      let node = null, resolveCancel;
      const cancelled = new Promise(resolve => { resolveCancel = resolve; });
      const cancel = () => {
        controller.abort();
        if (node) { try { node.stop(); } catch {} try { node.disconnect(); } catch {} }
        resolveCancel();
      };
      cancelCurrent = cancel;
      // Bound failed fetch/decode/resume/ended events so one failure cannot block the queue.
      const timeout = setTimeout(cancel, 20000);
      const valid = () => !controller.signal.aborted && version === generation;
      const register = next => {
        node = next;
        if (!valid()) { try { node.stop(); } catch {} try { node.disconnect(); } catch {} }
        return valid();
      };
      try {
        await Promise.race([cancelled, (async () => {
          try { await chime(register); } catch (error) { console.warn("Correct-word chime could not play", error); }
          if (!recording || !valid()) return;
          const AC = window.AudioContext || window.webkitAudioContext;
          if (!AC) return;
          const ctx = window.__hhkdClickCtx || (window.__hhkdClickCtx = new AC());
          if (ctx.state === "suspended") await ctx.resume();
          if (!valid()) return;
          const response = await fetch(recording, { signal: controller.signal });
          if (!response.ok) throw new Error(`Recording returned HTTP ${response.status}`);
          const buffer = await ctx.decodeAudioData(await response.arrayBuffer());
          if (!valid()) return;
          await new Promise((resolve, reject) => {
            const voice = ctx.createBufferSource();
            voice.buffer = buffer;
            voice.connect(ctx.destination);
            register(voice);
            voice.onended = resolve;
            try { voice.start(); } catch (error) { reject(error); }
          });
        })()]);
      } catch (error) {
        if (valid()) console.warn("Celebration audio could not play", error);
      } finally {
        clearTimeout(timeout);
        cancel();
        if (cancelCurrent === cancel) cancelCurrent = null;
      }
    }).catch(error => console.warn("Celebration audio queue failed", error));
    return queue;
  };
  return { play, stop, playRecording: recording => play(() => Promise.resolve(), null, recording) };
}
